<template>
  <v-layout wrap style="padding-top:50px;" v-if="totales">
      <!--v-card style="background-color:#90A4AE; width:340px; height:120px;padding-top:20px;margin-right:30px;">
        <v-layout wrap>
          <v-flex xs4>
            <center>
              <v-icon style="font-size: 70px;color:white;">mdi-television</v-icon>
            </center>
          </v-flex>
          <v-flex xs8>
            <center>
              <span class="itemNum">{{totales.TotalPantalla}}</span>
              <br>
              <span class="itemTitle">PANTALLAS EN REMOTO</span>
            </center>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card style="background-color:#7E57C2; width:200px; height:120px;padding-top:20px;margin-right:30px;">
        <center>
          <span class="itemNum">{{totales.Total}}</span>
          <br>
          <span class="itemTitle">TOTAL</span>
        </center>
      </v-card>
      <v-card style="background-color:#FFA726; width:200px; height:120px;padding-top:20px;margin-right:30px;">
        <center>
          <span class="itemNum">{{totales.Mantenimiento}}</span>
          <br>
          <span class="itemTitle">MANTENIMIENTO</span>
        </center>
      </v-card>
      <v-card style="background-color:#7CB240; width:200px; height:120px;padding-top:20px;margin-right:30px;">
        <center>
          <span class="itemNum">{{totales.EnLinea}}</span>
          <br>
          <span class="itemTitle">EN LÍNEA</span>
        </center>
      </v-card-->
      <v-card style="background-color:#D32F2F; width:200px; height:120px;padding-top:20px;margin-right: 30px;">
        <center>
          <span class="itemNum">{{totales.Incidencia}}</span>
          <br>
          <span class="itemTitle">INCIDENCIAS 42h</span>
        </center>
      </v-card>
      <v-card style="background-color:gray; width:1020px; height:120px;padding-top:25px;padding-left: 20px;margin-right:30px;color:white;">
      Muestra los player con estado de error y cuya fecha de error es < 42h. <b style="color: orange;">Los player con errores anteriores no saldrán.</b>
      <br/>
      <small>Por defecto los players están filtrados por:</small><br/>
      <b>PI</b> [pendiente de instalar] <b>TC</b> [temporalmente cerrado] <b>RC</b> [pendiente recuperación] <b>VI</b> [visionado] <b>T0</b> [tralink cero]
      </v-card>
  </v-layout>
</template>

<script>
import api from '@/services/api'
export default {
  props: {
    totales: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      // totales: null
    }
  },
  mounted () {
    // window.setInterval(() => {
    //   this.getData()
    // }, 300000)
    // this.getData()
  },
  methods: {
    getData () {
      
    }
  }
}
</script>

<style scoped>
  .itemNum {
    font-size: 40px;
    color: white;
  }
  .itemTitle {
    color: white;
  }
</style>
